<template>
  <div :class="['cec-page-bar', variantClass]">
    <div class="bar-inner px-3 py-2">
    <!-- ESQUERDA: filtros/tags -->
    <div class="bar-left d-flex align-items-center flex-wrap">
      <b-badge
        v-for="t in tags" :key="t.key + ':' + t.text"
        variant="info" class="mr-1 mb-1 chip-badge"
        :title="`Clique para remover (${t.key})`"
        @click="$emit('remove-tag', t)"
      >
        {{ t.text }} <span class="chip-x">×</span>
      </b-badge>
      <div v-if="!tags.length" class="text-muted small">Nenhum filtro aplicado</div>
    </div>

    <!-- DIREITA: Remover → Paginação → Range → Select -->
    <div class="bar-right">
      <b-button
        size="sm"
        :variant="colorirBotao"
        class="text-nowrap"
        :disabled="!tags.length"
        @click="$emit('clear')"
      >
        Remover filtro
      </b-button>

      <b-pagination
        v-model="localPage"
        :total-rows="totalRows"
        :per-page="localPerPage"
        size="sm"
        class="mb-0"
        @input="emitPage"
        first-number
        last-number
        limit="7"
      />

      <small class="text-muted mb-0 range">
        {{ rangeStart }}–{{ rangeEnd }} de {{ totalRows }}
      </small>

      <b-form-select
        v-model="localPerPage"
        :options="perPageOptions"
        size="sm"
        class="perpage"
        @input="emitPerPage"
      />
    </div>
  </div>
</div>

</template>

<script>
export default {
  name:'CecPageBar',
  props:{
    tags: { type:Array, default:()=>[] },
    variantClass: { type:String, default:'bg-light text-muted' },
    totalRows: { type:Number, default: 0 },
    perPage: { type:Number, default:10 },
    currentPage: { type:Number, default:1 }
  },
  data(){
    return {
      localPage: Number(this.currentPage) || 1,
      localPerPage: Number(this.perPage) || 10,
      perPageOptions: [5,10,25,50,100,250,500,1000].map(v => ({ value: v, text: `${v}/página` }))
    }
  },
  watch:{
    currentPage(v){ const n = Number(v)||1;  if (n !== this.localPage)     this.localPage = n },
    perPage(v){     const n = Number(v)||10; if (n !== this.localPerPage) this.localPerPage = n }
  },
  computed:{
    rangeStart(){
      if (!this.totalRows) return 0
      return (this.localPage - 1) * this.localPerPage + 1
    },
    rangeEnd(){
      return Math.min(this.totalRows, this.localPage * this.localPerPage)
    },
    colorirBotao() {
      return this.tags.length ? 'danger' : 'outline-danger'
    }
  },
  methods:{
    emitPage(){ this.$emit('page-change', Number(this.localPage) || 1) },
    emitPerPage(val){
      const n = Number(val) || this.localPerPage
      this.$emit('per-page-change', n)
    }
  },
  
}
</script>

<style>
.cec-page-bar{
  flex: 1 1 auto;
  min-width: 0;
}

.bar-inner{
  display:flex !important;
  align-items:center;
  justify-content:space-between;
  flex-wrap:wrap;
  width:100%;
}

.bar-left{ display:flex; align-items:center; flex-wrap:wrap; } 
.bar-right{
  display:flex;
  align-items:center;
  margin-left:auto;      
}
.bar-right > *{ margin-left:.5rem; }

.range{ white-space:nowrap; }
.perpage{ min-width:110px; }

@media (max-width:768px){
  .bar-right{ margin-left:0; width:100%; justify-content:flex-end; }
}

.chip-badge{ cursor:pointer; user-select:none; }
.chip-x{ font-weight:700; margin-left:.25rem; }
</style>


// WEBPACK FOOTER //
// src/components/Cec/CecPageBar.vue